/**
 * German copy used when BOOKING_RMD_3H_TIME_WINDOW is on.
 * Missing/false flag keeps the 2h strings in de.ts.
 */
const deThreeHourOverrides = {
  notificationBox: {
    description: {
      fixedDate:
        "Ihr Auftrag wird zur Zeit zur Auslieferung vorbereitet. Wir melden uns am Vortag der Lieferung mit einem 3h-Zeitfenster bei Ihnen."
    }
  },
  faq: {
    content: {
      myAppointment: {
        answer3: "<b>Zeitfensterwahl bei der Terminvereinbarung</b><br />" +
          "Im Rahmen der telefonischen oder Online-Terminbuchung stehen Ihnen verschiedene Zeitfenster zur Verfügung. Ob Ihnen ein Vormittags-, Nachmittags- oder Ganztagszeitfenster von uns angeboten werden kann, ist abhängig von Ihrem Händler.<br /><br />" +
          "<b>Wie wir Ihnen bei der weiteren Planunghelfen</b><br />" +
          "- <b>Zeitfenstereingrenzung</b>: Am Vortag der Lieferung (oder Abholung) grenzen wir Ihren Termin gegen 15 Uhr auf ein voraussichtliches 3-Stunden-Zeitfenster ein.<br /><br />" +
          "- <b>Telefonische Ankündigung</b>: Unser Lieferteam informiert Sie 30 bis 60 Minuten vor dem geplanten Eintreffen telefonisch über die genaue Ankunftszeit.",
        answer6: "Am Vortag Ihrer Lieferung oder Abholung grenzen wir Ihren Termin gegen 15 Uhr auf ein voraussichtliches 3-Stunden-Zeitfenster ein. Dies können Sie auf www.rhenusmydelivery.com einsehen. Zusätzlich informieren wir Sie per E-Mail.",
        answer8:
          "Loggen Sie sich auf www.rhenusmydelivery.com unter Angabe Ihrer Auftragsnummer und Postleitzahl ein. Im Reiter „Sendungsverfolgung“ können Sie jederzeit den aktuellen Status Ihrer Sendung inklusive vereinbartem Liefertermin einsehen. Ab 15 Uhr am Vortag der Auslieferung erhalten Sie hier zudem Details zum voraussichtlichen 3-Stunden-Zeitfenster der Zustellung.<br /><br />" +
          "<b>Live-Tracking</b><br />" +
          "Sobald unser Team am Liefertag in Zustellung geht, ist ein Live-Tracking in unserem Online-Kundenportal möglich. Hier wird zudem die Zahl der Stops bis zum Eintreffen und eine laufend aktualisierte Ankunftszeit angezeigt.",
        answer9: "Unser Anspruch ist es, Aufträge innerhalb des zuvor kommunizierten  3-Stunden-Zeitfensters durchzuführen. Leider kann sich der tatsächliche Zeitpunkt aufgrund unvorhersehbarer Umstände, wie ein erhöhtes Verkehrsaufkommen, verzögern. In diesem Fall empfehlen wir Ihnen, unsere Sendungsverfolgung in unserem Online-Kundenportal zu nutzen und die aktuelle Position unseres Lieferteams einzusehen."
      }
    }
  },
  appointment: {
    summary: {
      icsFileEmailBody:
        "Hallo {name},<br>Ihr Termin für Ihren {clientName}-Auftrag {orderNumber} steht fest.<br>" +
        "Das voraussichtliche Lieferzeitfenster wird am Vortag der Lieferung um ca. 15-16 Uhr auf 3 Stunden eingegrenzt.<br>" +
        "Diese und weitere Informationen rund um Ihre Lieferung können Sie auf Rhenusmydelivery.com/de einsehen.<br><br>" +
        '<a href="https://www.rhenusmydelivery.com/de">Jetzt Sendung verfolgen!</a><br><br>' +
        "Ihr Rhenus Home Delivery Team"
    }
  }
};

export default deThreeHourOverrides;
